import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://yzbsajoqplrmqjsiqvuq.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl6YnNham9xcGxybXFqc2lxdnVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODc4MDcxNTYsImV4cCI6MjAwMzM4MzE1Nn0.GyTkvpci_U5xh3ZXeUHWg88991GMEYRkQVFoOOZq0TY";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
